import ImportExport from "./ImportExport";

export default function Toolbar({
  onAddEvent,
  onAddTimeline,
  timelines,
  activeTimelineId,
  onSwitchTimeline,
  onDeleteTimeline,
  onImport,
  onExportJson,
  onExportSvg,
  onPrint,
  orientation,
  onToggleOrientation,
  expanded,
  onToggleExpand,
}) {
  return (
    <div className="toolbar">
      <div className="toolbar-inner">
        {/* Timeline switcher */}
        <div className="toolbar-group">
          <select className="timeline-select" value={activeTimelineId} onChange={(e) => onSwitchTimeline(e.target.value)}>
            {timelines.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
          </select>
        </div>

        <div className="toolbar-divider" />

        {/* Add buttons */}
        <div className="toolbar-group">
          <button className="toolbar-btn toolbar-btn-primary" onClick={onAddEvent} title="Add Event">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
            <span className="btn-label">Event</span>
          </button>

          <button className="toolbar-btn" onClick={onAddTimeline} title="New Timeline">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
              <line x1="8" y1="21" x2="16" y2="21" />
              <line x1="12" y1="17" x2="12" y2="21" />
            </svg>
            <span className="btn-label">Timeline</span>
          </button>
        </div>

        <div className="toolbar-divider" />

        {/* Orientation toggle */}
        <div className="toolbar-group">
          <button className="toolbar-btn" onClick={onToggleOrientation} title={`Toggle orientation (currently ${orientation})`}>
            {orientation === "vertical" ? (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="2" x2="12" y2="22" />
                <polyline points="8 6 12 2 16 6" />
                <polyline points="8 18 12 22 16 18" />
              </svg>
            ) : (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="2" y1="12" x2="22" y2="12" />
                <polyline points="6 8 2 12 6 16" />
                <polyline points="18 8 22 12 18 16" />
              </svg>
            )}
            <span className="btn-label">{orientation === "vertical" ? "Vertical" : "Horizontal"}</span>
          </button>
        </div>

        <div className="toolbar-divider" />

        {/* Expand / Collapse */}
        <div className="toolbar-group">
          <button
            className={`toolbar-btn${expanded ? " toolbar-btn-active" : ""}`}
            onClick={onToggleExpand}
            title={expanded ? "Fit to screen" : "Expand to full size"}
          >
            {expanded ? (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="4 14 10 14 10 20" />
                <polyline points="20 10 14 10 14 4" />
                <line x1="14" y1="10" x2="21" y2="3" />
                <line x1="3" y1="21" x2="10" y2="14" />
              </svg>
            ) : (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 3 21 3 21 9" />
                <polyline points="9 21 3 21 3 15" />
                <line x1="21" y1="3" x2="14" y2="10" />
                <line x1="3" y1="21" x2="10" y2="14" />
              </svg>
            )}
            <span className="btn-label">{expanded ? "Collapse" : "Expand"}</span>
          </button>
        </div>

        <div className="toolbar-divider" />

        {/* Import / Export */}
        <div className="toolbar-group">
          <ImportExport onImport={onImport} onExportJson={onExportJson} onExportSvg={onExportSvg} onPrint={onPrint} />
        </div>

        {/* Delete timeline (if more than one) */}
        {timelines.length > 1 && (
          <>
            <div className="toolbar-divider" />
            <div className="toolbar-group">
              <button
                className="toolbar-btn toolbar-btn-danger"
                onClick={() => {
                  if (confirm(`Delete timeline "${timelines.find((t) => t.id === activeTimelineId)?.name}"?`)) {
                    onDeleteTimeline(activeTimelineId);
                  }
                }}
                title="Delete current timeline"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="3 6 5 6 21 6" />
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                </svg>
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
